import React from "react";

interface MetricCardProps {
  title: string;
  value: string;
  changePercentage: string;
  changeDirection: "up" | "down";
  comparisonText?: string; // Changed from changeText
  chartImageUrl?: string; // Changed from chartImage
  className?: string;
  toggleSwitch?: {
    label: string;
    isChecked: boolean;
    onToggle: () => void;
  };
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  changePercentage,
  changeDirection,
  comparisonText,
  chartImageUrl,
  className,
  toggleSwitch,
}) => {
  return (
    <article
      className={`relative px-4 py-5 w-full bg-white rounded-xl border border-solid shadow-sm border-[color:var(--Colors-Border-border-secondary,#EAECF0)] ${className || ""}`}
    >
      <h3 className="z-0 text-base font-semibold text-gray-900">{title}</h3>
      <div className="flex z-0 gap-4 items-end mt-5 w-full">
        <div className="flex-1 shrink basis-0">
          <div className="text-3xl font-semibold leading-none text-gray-900">
            {value}
          </div>
          <div className="flex gap-2 items-center mt-4 w-full text-sm font-medium leading-none">
            <div className="flex gap-0.5 justify-center items-center self-stretch my-auto text-center text-blue-700 whitespace-nowrap">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/b3fe04040072d22698d476b5dd0ff3965492a54c?placeholderIfAbsent=true"
                className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
                alt={`${changeDirection} arrow`}
              />
              <span className="self-stretch my-auto">{changePercentage}</span>
            </div>
            <div className="flex-1 shrink self-stretch my-auto basis-0 text-ellipsis text-slate-600">
              {comparisonText}
            </div>
          </div>
        </div>
        {chartImageUrl && (
          <img
            src={chartImageUrl}
            className="object-contain shrink-0 w-24 aspect-[2]"
            alt="Usage chart"
          />
        )}
      </div>
      {toggleSwitch ? (
        <div className="absolute top-4 right-4 z-0 flex items-center">
          <span className="text-xs text-gray-500 mr-2">{toggleSwitch.label}</span>
          <label className="relative inline-flex items-center cursor-pointer">
            <input 
              type="checkbox" 
              className="sr-only peer" 
              checked={toggleSwitch.isChecked}
              onChange={toggleSwitch.onToggle}
            />
            <div className="w-9 h-5 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600"></div>
          </label>
        </div>
      ) : (
        <button
          className="absolute top-4 right-4 z-0 w-5"
          aria-label="Open dropdown menu"
        >
          <img
            src="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/174fe0ec676bf4780e267cf5e23f22bfc0464194?placeholderIfAbsent=true"
            className="object-contain w-full aspect-square"
            alt="Options"
          />
        </button>
      )}
    </article>
  );
};

export default MetricCard;
